// Module
var code = "<div class=\"connection-test-entry {{status}}\"> <div class=\"validation-list\"> <div class=\"icon fa {{status}}\"></div> <div class=\"operation-name\">{{text}}</div> </div> <% if (remedy) { %> <div class=\"connection-remedy\"> {{remedy}} </div> <% } %> </div> ";
// Exports
export default code;